import { createKeyAtPath } from '@/utilities/db-helpers'

export default {
  namespaced: true,

  actions: {
    update(
      {
        dispatch,
        rootGetters: { [`battles/battle`]: battle },
      },
      { affected, ...data }
    ) {
      const updates = {}
      Object.entries(data).forEach(([key, value]) => {
        updates[
          `/battleCombatants/${battle}/${affected}/effects/${data.id}/${key}`
        ] = value
      })
      return dispatch(`updateDb`, updates, { root: true })
    },

    create(
      {
        dispatch,
        rootGetters: { [`battles/battle`]: battle },
      },
      { affected, ...data }
    ) {
      const path = `/battleCombatants/${battle}/${affected}/effects`
      data.id = createKeyAtPath(path)

      const updates = {
        [`${path}/${data.id}`]: {
          ...data,
          duration: 1,
        },
      }
      return dispatch(`updateDb`, updates, { root: true })
    },

    destroy(
      {
        dispatch,
        rootGetters: { [`battles/battle`]: battle },
      },
      { affected, id }
    ) {
      const updates = {
        [`/battleCombatants/${battle}/${affected}/effects/${id}`]: null,
      }
      return dispatch(`updateDb`, updates, { root: true })
    },
  },
}
